<!--自用车辆、机械清单-->
<template>
    <div>
        <div id="formHtml" style="padding:30px 30px;">
            <div
                style="padding:10px 0px;display:flex;flex-direction: row;justify-content: flex-start;align-items: center;">
                <span>企业名称（盖章）:</span>
                <EnterpriseSelect v-model="form.entId" entType="0" @changeInfo="({ label }) => form.entName = label"
                    v-if="entType == 3">
                </EnterpriseSelect>
                <span v-else>{{ form.entName }}</span>
            </div>
            <div style="background:#1c1c1c;">
                <table cellspacing="1" cellpadding="0" width="100%">
                    <tr>
                        <td colspan="5" style="height:80px;"><span style="font-size:20px;">企业自用车辆信息登记表</span></td>
                    </tr>
                    <tr>
                        <td rowspan="2" style="width:65px;">序号</td>
                        <td rowspan="2" style="width:180px;">车牌号码</td>
                        <td colspan="2">匀选车辆隶属关系（注）</td>
                        <td rowspan="2">备注</td>
                    </tr>
                    <tr>
                        <td>自有</td>
                        <td>租赁</td>
                    </tr>

                    <tr v-for="(obj, index) in form.list" :key="obj.listId">
                        <td>{{ index }} <i class="el-icon-delete deleteBtn" @click="form.list.splice(index, 1)">删除</i>
                        </td>
                        <td>
                            <input v-model="obj.devNo" type="text" :class="edit(obj.devNo)" />
                        </td>
                        <td @click="obj.useType = 0">
                            <div v-if="obj.useType == 0">√</div>
                        </td>
                        <td @click="obj.useType = 1">
                            <div v-if="obj.useType == 1">√</div>
                        </td>
                        <td><input v-model="obj.remark" type="text" :class="edit(obj.remark)" /></td>
                    </tr>
                </table>
            </div>
        </div>
        <div style="padding:30px 30px;">
            <el-button size="small" type="success" @click="addRow">添加一行</el-button>
            <el-button size="small" type="success" @click="addMulRow(10)">添加十行</el-button>
            <el-button size="small" type="primary" @click="multiInputVisible = true">批量输入</el-button>
            <el-button size="small" type="warning" @click="selectCarMeta">从车辆信息库选择</el-button>
        </div>

        <a id="download" v-show="false"></a>

        <div class="dialog-footer" style="margin-top:10px;text-align: center;">
            <el-button @click="closeDialog()" size="small">取 消</el-button>
            <el-button size="small" type="primary" v-if="!prop.preview" @click="create('form')">保存</el-button>
        </div>

        <el-drawer title="车辆选择" :modal="false" :visible.sync="carMetaComponentsVisible" :key="carMetaComponentsVisible"
            direction="rtl" size="50%">
            <div>
                <CarMetaComponents :selectedIds="selectedIds" @input="selectCarHandler"></CarMetaComponents>
            </div>
        </el-drawer>

        <BatchInput v-model="multiInputVisible" @changeInfo="batchInput">
            <div style="padding:10px 0;">
                选择此批录入的车辆隶属关系：
                <el-radio-group v-model="useType">
                    <el-radio :label="0">自有</el-radio>
                    <el-radio :label="1">租赁</el-radio>
                </el-radio-group>
            </div>
        </BatchInput>
    </div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import {
    enterpriseDetail
} from "../../../api/admin/sysEnterprise/index";
import * as html2canvas from "html2canvas";
import {
    addObj,
    getObj,
    putObj
} from "../../../api/admin/sysFormMachinery/index";
import CarMetaComponents from "../common/CarMetaComponents.vue"
import EnterpriseSelect from "@/pages/admin/components/EnterpriseSelect/index";
import BatchInput from "@/pages/admin/components/BatchInput/index";
export default {
    name: 'machineryList',
    props: ["formId", "prop"],
    components: {
        CarMetaComponents, EnterpriseSelect, BatchInput
    },
    data() {
        return {
            //多行输入Show
            multiInputVisible: false,
            //当前登录用户企业类型
            entType: null,
            carMetaComponentsVisible: false,
            useType: 0,
            form: {
                formId: null,
                entId: null,
                entName: null,
                list: [{
                    listId: null,
                    devNo: null,
                    remark: null,
                    useType: null,
                    devType1: 0
                }]
            },
            types: [{
                value: "车辆",
                label: "车辆"
            },
            {
                value: "其他机械",
                label: "其他机械"
            },
            ]
        }
    },
    created() {
        this.init();
    },
    computed: {
        ...mapGetters([
            'elements'
        ]),
        "selectedIds": function () {
            return this.form.list.map(x => x.devNo);
        }
    },
    methods: {
        init: function () {
            if (this.formId) {
                getObj(this.formId).then(response => {
                    this.form = response;
                })
            } else {
                enterpriseDetail({}).then(response => {
                    this.entType = response.entType;
                    this.form.entName = response.entName;
                });
            }
        },
        html(callback) {
            html2canvas(document.querySelector("#formHtml"), {
                scale: 2
            }).then(canvas => {
                callback && callback(canvas);
            })
        },
        download(fileName) {
            this.html((canvas) => {
                fileName += ".png";
                if (window.navigator.msSaveBlob) {
                    var blob = canvas.msToBlob()
                    window.navigator.msSaveBlob(blob, fileName)
                } else {
                    var url = canvas.toDataURL() //把canvas转成base64
                    // 写一个隐藏的按标签，借助按标签的download属性下载图片
                    document.querySelector('#download').href = url;
                    document.querySelector('#download').download = fileName;
                    document.querySelector('#download').click()
                }
            });
        },
        create() {
            this.editStatus = false;
            this.$nextTick(() => {
                addObj(this.form).then((response) => {
                    this.html(canvas => {
                        this.$emit("on-success", {
                            ...response,
                            content: canvas.toDataURL()
                        });
                    })
                })
            })
        },
        batchInput: function (list) {
            list.forEach(x => {
                this.addRow({ devNo: x, useType: this.useType });
            })
        },
        addMulRow: function (row = 1) {
            for (let i = 0; i < row; i++) {
                this.addRow();
            }
        },
        addRow: function (row) {
            let obj = {
                ...this.form.list[0]
            }
            Object.keys(obj).forEach(x => {
                obj[x] = null;
            });
            if (row) {
                Object.assign(obj, row)
            }
            this.form.list.push(obj);
        },
        onMouseDown(index, useType) {
            this.form.list[index].useType = useType;
        },
        edit: function (val) {
            if (val && String.valueOf(val).length > 0 || this.prop.preview) {
                return "edit";
            }
            return "";
        },
        selectCarMeta: function () {
            this.carMetaComponentsVisible = true;
        },
        selectCarHandler(list) {
            list = list || [];
            list = list.filter(x => !this.selectedIds.includes(x.devNo));
            if (list && list.length > 0) {
                this.form.list = [...this.form.list, ...list];
            }
        },
        closeDialog() {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
table td {
    background: #FFF;
    padding: 0px 4px;
    height: 40px;
    box-sizing: border-box;
    text-align: center;
}

table td .checkbox {
    width: 16px;
    height: 16px;
    border: solid 1px #000;
    background: #FFF;
    position: relative;
    top: 3px;
}

table td input {
    background: url(./img/edit.png) 10px no-repeat;
    width: 100%;
    height: 100%;
    border: none;
    text-indent: 0px;
    border: none;
    font-size: 14px;
    outline: none;
    padding-left: 10px;
    box-sizing: border-box;
}

table td .shortInput {
    width: 60px;
    height: 100%;
    border: none;
}

table td .longInput {
    width: 290px;
    height: 100%;
    border: none;
}

table td .deleteBtn {
    cursor: pointer;
    display: none;
    color: red;
}

table td:hover .deleteBtn {
    display: block;
}

.edit {
    background: transparent;
}
</style>
